module.exports = __webpack_public_path__ + "img/airbase-stage_5.3.ed0c96fc.jpg";